
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { isValidFloatNumber } from '@/helpers/isValidFloatNumber';
import { RadiochemRnDetecModeEnum, RadiochemRnDetecUnitEnum } from '@/modules/analysis/models/radiochemEnum';

export interface FormRcRnValue {
  isActive?: boolean;
  label: string;
  detectionMode: string;
  value: string;
  detectionUnit: string;
}

@Component({
  components: {}
})
export default class RadiochemRadionuclideInput extends Vue {
  @Prop({ required: true })
  protected disabled!: boolean;
  @Prop({ required: true })
  protected value!: FormRcRnValue;
  protected checkboxValue = false;
  protected inputDetectionMode = '';
  protected inputValue = '';
  protected inputDetectionUnit = '';

  protected created(): void {
    this.setInitialValue();
  }

  protected verifyFloatNumber(value: string): boolean {
    return isValidFloatNumber(value);
  }

  @Watch('value', { immediate: true })
  protected setInitialValue(): void {
    this.checkboxValue = this.value.isActive || false;
    this.inputDetectionMode = this.value.detectionMode;
    this.inputValue = this.value.value;
    this.inputDetectionUnit = this.value.detectionUnit;
  }

  protected get radiochemRnDectecOptions(): { text: string; value: string }[] {
    return [
      {
        text: this.$i18n.t('common.radiochemDetectMode.threshold').toString(),
        value: RadiochemRnDetecModeEnum.THRESHOLD
      },
      {
        text: this.$i18n.t('common.radiochemDetectMode.limit').toString(),
        value: RadiochemRnDetecModeEnum.LIMIT
      }
    ];
  }

  protected get radiochemRnDectecUnits(): { text: string; value: string }[] {
    return [
      {
        text: this.$i18n.t('common.radiochemDetectUnit.bqkg').toString(),
        value: RadiochemRnDetecUnitEnum.BQ_PER_KG
      },
      {
        text: this.$i18n.t('common.radiochemDetectUnit.bqg').toString(),
        value: RadiochemRnDetecUnitEnum.BQ_PER_G
      },
      {
        text: this.$i18n.t('common.radiochemDetectUnit.bql').toString(),
        value: RadiochemRnDetecUnitEnum.BQ_PER_L
      }
    ];
  }

  protected get radionuclide(): string {
    return this.value.label;
  }

  protected get currentInput(): FormRcRnValue {
    return {
      isActive: this.checkboxValue,
      label: this.radionuclide,
      detectionMode: this.inputDetectionMode,
      value: this.inputValue,
      detectionUnit: this.inputDetectionUnit
    };
  }
}
